import React, { useEffect, useState } from 'react'; 
import { Button } from '@progress/kendo-react-buttons';
import { FormComboBox, FormInput, FormNumericTextBox } from '../validation/Form-Components';
import { bankAcctNoValidator, decimalValidator, max10decimalValidator, numericValidator, reqDDLValidator, requiredValidator } from '../validation/Validators';
import bankNameList from '../hybriddata/bankNames.json';
import { Field } from '@progress/kendo-react-form';
import currencyList from '../hybriddata/currencyList.json';
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import { filterBy } from "@progress/kendo-data-query";
import helper from '../factory/Helper';

const AddBankBalncePopup = (props) => {

    const CloseModalButton = styled(MdClose)`
    color: white;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    //padding: 0;
    // z-index: 10;
    //top: 16px;
  `;

    const { popupValue, lastSixMonths, editedItem,fProps }= props;

    const [fBankNameList, setFBankNameList] = useState(bankNameList.slice());
    const [fCurrencies, setFCurrencies] = useState(currencyList.slice());

    const[isFormEdited,setIsFormEdited] = useState(false);

    useEffect(() => {
        console.log('@AddBankBalncePopup useEffect');
        // console.log('editedItem',editedItem);
        let bankName={},acctNumValue=undefined,currency={},balanceAmt=null;
        // let bankBalance1=0,bankBalance2=0,bankBalance3=0,bankBalance4=0,bankBalance5=0,bankBalance6=0;
        if(editedItem !== null) {
            setIsFormEdited(true);
            bankName = editedItem.bankName;
            acctNumValue = editedItem.accountNumber;
            currency = editedItem.currency;
            balanceAmt = parseFloat(editedItem.sixMonthsBalanceAmt);

            
            // bankBalance1 = editedItem.balanceHistory[0].monthEndBal;
            // bankBalance2 = editedItem.balanceHistory[1].monthEndBal;
            // bankBalance3 = editedItem.balanceHistory[2].monthEndBal;
            // bankBalance4 = editedItem.balanceHistory[3].monthEndBal;
            // bankBalance5 = editedItem.balanceHistory[4].monthEndBal;
            // bankBalance6 = editedItem.balanceHistory[5].monthEndBal;
        }

        fProps.onChange('BankName', { value: bankName});
        fProps.onChange('AcctNo', { value: acctNumValue});
        fProps.onChange('Currency', { value: currency});
        fProps.onChange('sixMonthsBalanceAmt', { value: balanceAmt});

        // fProps.onChange('bankBalance1', { value: bankBalance1});
        // fProps.onChange('bankBalance2', { value: bankBalance2});
        // fProps.onChange('bankBalance3', { value: bankBalance3});
        // fProps.onChange('bankBalance4', { value: bankBalance4});
        // fProps.onChange('bankBalance5', { value: bankBalance5});
        // fProps.onChange('bankBalance6', { value: bankBalance6});
    }, []);
    
    const handleSetTrigger = () => {
        props.setTrigger();
    }

    const handleProceed = (dataItem) => {
        const params = formatJsonParams();
 
        props.onClickAdd(params,isFormEdited);
    }

    const formatJsonParams = () => {
        const ddlBankName = fProps.valueGetter("BankName");
        const accountNum = fProps.valueGetter("AcctNo");
        const ddlCurrency = fProps.valueGetter("Currency");
        const balanceAmt = fProps.valueGetter("sixMonthsBalanceAmt");

        // const balance1 = fProps.valueGetter("bankBalance1"); 
        // const balance2 = fProps.valueGetter("bankBalance2"); 
        // const balance3 = fProps.valueGetter("bankBalance3"); 
        // const balance4 = fProps.valueGetter("bankBalance4"); 
        // const balance5 = fProps.valueGetter("bankBalance5"); 
        // const balance6 = fProps.valueGetter("bankBalance6"); 

        const bankBalanceDetails = {
            bankName:ddlBankName,
            accountNumber: accountNum,
            currency: ddlCurrency,
            sixMonthsBalanceAmt: balanceAmt.toFixed(2)
            // balanceHistory: [
            //     {
            //         date:lastSixMonths[0],
            //         monthEndBal:balance1,
            //     },
            //     {
            //         date:lastSixMonths[1],
            //         monthEndBal:balance2,
            //     },
            //     {
            //         date:lastSixMonths[2],
            //         monthEndBal:balance3,
            //     },
            //     {
            //         date:lastSixMonths[3],
            //         monthEndBal:balance4,
            //     },
            //     {
            //         date:lastSixMonths[4],
            //         monthEndBal:balance5,
            //     },
            //     {
            //         date:lastSixMonths[5],
            //         monthEndBal:balance6,
            //     },
            // ]
        }
        return bankBalanceDetails;
    }

    const disabledBtnAdd = ()=>{
        let result = false;
        const ddlBankName = fProps.valueGetter("BankName");
        const accountNum = fProps.valueGetter("AcctNo");
        const ddlCurrency = fProps.valueGetter("Currency");
        const balanceAmt = fProps.valueGetter("sixMonthsBalanceAmt");
        // const balance1 = fProps.valueGetter("bankBalance1"); 
        // const balance2 = fProps.valueGetter("bankBalance2"); 
        // const balance3 = fProps.valueGetter("bankBalance3"); 
        // const balance4 = fProps.valueGetter("bankBalance4"); 
        // const balance5 = fProps.valueGetter("bankBalance5"); 
        // const balance6 = fProps.valueGetter("bankBalance6"); 

        if(ddlBankName === null || accountNum === undefined || accountNum === '' || ddlCurrency === null || balanceAmt === null) {
            result = true;
        }
        else if(helper.isEmptyObj(ddlBankName) || helper.isEmptyObj(ddlCurrency)) {
            result = true;
        }
   
        return result;
    }

    const filterData = (filter) => {
        const data = bankNameList.slice();
        return filterBy(data, filter);
    };
    
    const filterChange = (event) => {
        setFBankNameList(filterData(event.filter));
    };

    const filterCurrencyData = (filter) => {
        const data = currencyList.slice();
        return filterBy(data, filter);
    };
    
    const filterCurrencyChange = (event) => {
        setFCurrencies(filterCurrencyData(event.filter));
    };

    return props.popupValue && (
        <div className="popup">
        <div className="aip-popup-inner">
            <CloseModalButton
                aria-label="Close modal"
                onClick={() => props.setTrigger(false)}
            />
            <div className="fbaPSize">
                <div className="bgBlackYellowBorder">
                    <div className="row around-xs inputPair">
                        <div className="col-11">
                            <div className="dcPgmh">{'Add Bank Balance'}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{paddingTop:'10px'}}>
                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{'Bank Name'}</div>
                        <Field id={'BankName'} 
                            name={'BankName'}
                            component={FormComboBox}
                            textField={'label'}
                            filterable={true}
                            onFilterChange={filterChange}
                            data={fBankNameList}
                            placeholder={'Please select'}
                            validator={reqDDLValidator}
                        />
                    </div>
                </div>
              
                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div>{'Account Number'}</div>
                        <Field component={FormInput} 
                            id={'AcctNo'}
                            name={'AcctNo'}
                            placeholder={'Please input'} 
                            maxLength={80} 
                            validator={bankAcctNoValidator}
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{'Currency'}</div>
                        <Field id={'Currency'} 
                            name={'Currency'}
                            component={FormComboBox}
                            textField={'label'}
                            filterable={true}
                            onFilterChange={filterCurrencyChange}
                            data={fCurrencies}
                            placeholder={'Please select'}
                            validator={reqDDLValidator}
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{'Average Month End Balance of Past 6 months'} </div>
                        <Field component={FormNumericTextBox}
                            id={'sixMonthsBalanceAmt'}
                            name={'sixMonthsBalanceAmt'}
                            placeholder={'S$0'}
                            min={0}
                            spinners={false} 
                            format="c2"
                        />
                    </div>
                </div>

                {/* <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{lastSixMonths[0]+' Month End Bank Balance'} </div>
                        <Field component={FormNumericTextBox}
                            id={'bankBalance1'}
                            name={'bankBalance1'}
                            placeholder={'S$'}
                            min={0}
                            defaultValue={0}
                            spinners={false} 
                            format="c2"
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{lastSixMonths[1]+' Month End Bank Balance'} </div>
                        <Field component={FormNumericTextBox}
                            id={'bankBalance2'}
                            name={'bankBalance2'}
                            placeholder={'S$'}
                            min={0}
                            defaultValue={0}
                            spinners={false} 
                            format="c2"
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{lastSixMonths[2]+' Month End Bank Balance'} </div>
                        <Field component={FormNumericTextBox}
                            id={'bankBalance3'}
                            name={'bankBalance3'}
                            placeholder={'S$'}
                            min={0}
                            defaultValue={0}
                            spinners={false} 
                            format="c2"
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{lastSixMonths[3]+' Month End Bank Balance'} </div>
                        <Field component={FormNumericTextBox}
                            id={'bankBalance4'}
                            name={'bankBalance4'}
                            placeholder={'S$'}
                            min={0}
                            defaultValue={0}
                            spinners={false} 
                            format="c2"
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{lastSixMonths[4]+' Month End Bank Balance'} </div>
                        <Field component={FormNumericTextBox}
                            id={'bankBalance5'}
                            name={'bankBalance5'}
                            placeholder={'S$'}
                            min={0}
                            defaultValue={0}
                            spinners={false} 
                            format="c2"
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{lastSixMonths[5]+' Month End Bank Balance'} </div>
                        <Field component={FormNumericTextBox}
                            id={'bankBalance6'}
                            name={'bankBalance6'}
                            placeholder={'S$'}
                            min={0}
                            spinners={false} 
                            format="c2"
                        />
                    </div>
                </div> */}
            </div>
            <div style={{paddingTop:'10px'}}>
                <div className='popupbtn'>
                    <Button className="k-button btn btn-success" 
                        disabled={disabledBtnAdd()}
                        onClick={handleProceed}>{'ADD'}</Button> 
                </div>
            </div>
        </div>
        </div>
    )
}

export default AddBankBalncePopup;